module.exports = __webpack_public_path__ + "static/media/Header2.f5c99bb1.jpg";